// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1C_Zr","content":"styles_content__ZmeNM","selectAll":"styles_selectAll__tyukA"};